import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../context/GlobalContext';
import CustomerLedgerTableDataLayer from './CustomerLedgerTableDataLayer';
import { Languages } from '../Utils/Languages';
import { useNavigate } from 'react-router-dom';

const CustomerLedgerListLayer = () => {
    const { state } = useContext(ConfigContext);
    const navigate = useNavigate();

    return (
        <div className="card basic-data-table">
            <CustomerLedgerTableDataLayer businessData={state?.BUSINESSES} />
        </div >


    );
};

export default CustomerLedgerListLayer;